<template>
  <div class="d-flex flex-column">
    <span class="consumer-header-title cinza-d10-text mb-2">{{ consumer.name || 'Cliente não identificado' }}</span>

    <div class="consumer-info">
      <span class="cinza-d10-text" style="min-width: 20%">
        {{ documentLabel }}
        <span class="cinza-0-text"> {{ consumer.documentNo | cpfCnpj }}</span>
      </span>
      <span class="cinza-d10-text">
        Telefone:
        <span class="cinza-0-text"> {{ consumer.phone | telefone }}</span>
      </span>
    </div>

    <div class="consumer-info">
      <span class="cinza-d10-text" style="min-width: 20%">
        {{ dateLabel }}
        <span class="cinza-0-text"> {{ dateRange }}</span>
      </span>
      <span v-if="unitName" class="cinza-d10-text">
        Loja selecionada:
        <span class="cinza-0-text"> {{ unitName }}</span>
      </span>
    </div>

    <select-products-dialog v-if="products && products.length > 0" :selected-products="products" button-type="link" view-only />
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import SelectProductsDialog from '@/components/select-products/SelectProductsDialog.vue'

export default {
  name: 'ConsumerHeader',
  components: {
    SelectProductsDialog,
  },
  props: {
    consumer: {
      type: Object,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      default: '',
    },
    unitName: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    documentLabel() {
      return this.consumer?.documentNo?.length > 11 ? 'CNPJ:' : 'CPF:'
    },
    dateLabel() {
      if (this.endDate && this.endDate.length > 0) {
        return 'Período: '
      }
      return 'Data: '
    },
    dateRange() {
      if (this.endDate && this.endDate.length > 0) {
        return `${DateTime.fromISO(this.startDate).toFormat('dd/MM/yyyy')} - ${DateTime.fromISO(this.endDate).toFormat('dd/MM/yyyy')}`
      }
      return `${DateTime.fromISO(this.startDate).toFormat('dd/MM/yyyy')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.cinza-d10-text {
  color: $cinza-d10;
}

.cinza-0-text {
  color: $cinza-0;
}

.consumer-header-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.consumer-info {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 933px) {
  .consumer-info {
    flex-direction: row;
    gap: 18px;
    margin-bottom: 8px;
  }
}
</style>
